import { inject, Injectable } from '@angular/core';
import { ICorrelationSpectrum } from '@app/api/interfaces/chart-data/correlation-spectrum';
import { DayJSDateFormat } from '@app/core/enums/date-format.enum';
import { DayjsLocaleService } from '@app/core/i18n/services/dayjs-locale.service';
import { CsvColumnConfig, CsvExportService } from '@app/core/services/csv-export/csv-export.service';
import { CsvExportFormattingService } from '@app/core/services/csv-export/csv-export-formatting.service';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { _, TranslateService } from '@ngx-translate/core';

@Injectable()
export class FpCorrelationSpectrumExportService {
  protected readonly csvExportService = inject(CsvExportService);
  protected readonly csvFormat = inject(CsvExportFormattingService);
  protected readonly dayjsLocale = inject(DayjsLocaleService);
  private readonly translate = inject(TranslateService);

  private getCsvColumnConfig(): CsvColumnConfig<ICorrelationSpectrum>[] {
    return [
      {
        header: this.translate.instant(_('@@chart-export-csv-header-frequency')),
        value: row => this.csvFormat.formatNumber(row.frequency),
      },
      {
        header: this.translate.instant(_('@@chart-export-csv-header-spectrum-db-value')),
        value: row => this.csvFormat.formatNumber(row.spectrumDbValue),
      },
    ];
  }

  public exportCsv(popupMainData: IFpCorrelationData, data: ICorrelationSpectrum[]): void {
    const serialNo1 = popupMainData.loggerDeployment1.serialNo;
    const serialNo2 = popupMainData.loggerDeployment2.serialNo;
    const date = popupMainData.correlation.soundSignalStartAt;

    const formattedDate = this.dayjsLocale.dayjs(date).format(DayJSDateFormat.YYYYMMDD_HHmm);

    const columns = this.getCsvColumnConfig();

    this.csvExportService.downloadCsv(
      `CorrelationSpectrum_${serialNo1}_${serialNo2}_${formattedDate}.csv`,
      data,
      columns
    );
  }
}
